// 出水水质分析
import React from "react";
import * as echarts from "echarts/lib/echarts";
import moment from "moment";

let myChart = null;
class Ocharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <div id="ocharts"></div>;
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart
      ? echarts.init(document.getElementById("ocharts"))
      : myChart;
    const day = [];
    const value = [];

    nextProps.data &&
      nextProps.data.forEach((item) => {
        day.push(item.createTime);
        value.push(item.value);
      });

    let option = {
      backgroundColor: "#fff",
      color: ["#73A0FA", "#73DEB3", "#9013FE", "#FFB761"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
          lineStyle: {
            type: "dashed",
          },
        },
      },
      grid: {
        left: "25",
        right: "25",
        bottom: "44",
        top: "85",
        containLabel: true,
      },
      legend: {
        data: ["药剂量"],
        orient: "horizontal",
        icon: "rect",
        show: true,
        left: 20,
        top: 5,
      },
      xAxis: {
        type: "category",
        data: day,
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
      },
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
        {
          start: 0,
          end: 100,
        },
      ],
      yAxis: {
        type: "value",
        axisLabel: {
          color: "#999",
          fontSize: 12,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#F3F4F4",
          },
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        name: "mg/L",
      },
      series: [
        {
          name: "药剂量",
          type: "line",
          smooth: true,
          data: value,
        },
      ],
    };

    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn () {
    myChart.resize();
  }

  componentWillUnmount() {
    myChart = null;
    window.removeEventListener("resize", this.resizeFn);
  }
}

export default Ocharts;
